'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

// lib
import Button, { ButtonProps } from '../button'
import Text, { TextProps } from '../text'
import { ThemeVariantContext, ThemeVariants } from '../_support'

type SupportedVariants = Extract<ThemeVariants, 'default' | 'violet' | 'gray'>

type Variants = Record<SupportedVariants, ButtonProps>

const variants: Variants = {
  default: {
    bg: 'paleViolet',
    variant: 'punchThroughViolet'
  },
  violet: {
    variant: 'violet'
  },
  gray: { variant: 'gray' }
}

/* -----------------------------------------------------------------------------
 * SelectSectionTitle
 * -------------------------------------------------------------------------- */

const SelectSectionTitle = React.forwardRef<HTMLElement, TextProps>(
  (props: TextProps, ref) => {
    return (
      <Text
        mt='12'
        textColor='purple'
        font='text.14.bold'
        ref={ref}
        style={{ cursor: 'default' } as any}
        {...props}
      />
    )
  }
)

/* -----------------------------------------------------------------------------
 * SelectBadgeOption
 * -------------------------------------------------------------------------- */

const SelectBadgeOption = React.forwardRef<HTMLElement, ButtonProps>(
  (props: ButtonProps, ref) => {
    const themeVariant = React.useContext(ThemeVariantContext)
    const allProps = {
      ...variants[themeVariant],
      ...props
    }

    return (
      <Button
        shape='rectangular'
        size='small'
        mt='12'
        maxWidth='fit-content'
        ref={ref}
        {...allProps}
      />
    )
  }
)

/* -----------------------------------------------------------------------------
 * SelectOption
 * -------------------------------------------------------------------------- */

export default {
  Badge: SelectBadgeOption,
  Title: SelectSectionTitle
}
